import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { ImportsPageView } from '../../features/imports/imports-page-view';
import { usePartnerId } from '../../features/inbox/use-partner-name';

export const Route = createFileRoute('/imports/')({
  staticData: {
    breadcrumb: 'Work Order Imports',
    layout: 'default',
  },
  component: ImportsPage,
});

function ImportsPage() {
  const enabled = useFeatureFlag('imports');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Work Order Imports is not available</h2>
        <p className="text-muted-foreground text-sm">
          Work Order Imports is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <ImportsPageView partnerId={partnerId} />;
}
